import { create } from 'zustand';

const TOUR_KEY = 'bb.tour_completed';
const ADMIN_TOUR_KEY = 'bb.admin_tour_completed';

function readCompleted(): boolean {
  try {
    return localStorage.getItem(TOUR_KEY) === '1';
  } catch {
    return false;
  }
}

function writeCompleted(v: boolean): void {
  try {
    if (v) localStorage.setItem(TOUR_KEY, '1');
    else localStorage.removeItem(TOUR_KEY);
  } catch {
    /* ignore */
  }
}

function readAdminCompleted(): boolean {
  try {
    return localStorage.getItem(ADMIN_TOUR_KEY) === '1';
  } catch {
    return false;
  }
}

function writeAdminCompleted(v: boolean): void {
  try {
    if (v) localStorage.setItem(ADMIN_TOUR_KEY, '1');
    else localStorage.removeItem(ADMIN_TOUR_KEY);
  } catch {
    /* ignore */
  }
}

interface TourState {
  tourCompleted: boolean;
  tourStep: number;
  showTour: boolean;
  startTour: () => void;
  nextStep: () => void;
  dismissTour: () => void;

  adminTourCompleted: boolean;
  adminTourStep: number;
  showAdminTour: boolean;
  startAdminTour: () => void;
  nextAdminStep: () => void;
  dismissAdminTour: () => void;
}

export const useTourStore = create<TourState>((set) => ({
  tourCompleted: readCompleted(),
  tourStep: 0,
  showTour: false,
  startTour: () => set({ showTour: true, tourStep: 0 }),
  nextStep: () => set((s) => ({ tourStep: s.tourStep + 1 })),
  dismissTour: () => {
    writeCompleted(true);
    set({ showTour: false, tourStep: 0, tourCompleted: true });
  },

  adminTourCompleted: readAdminCompleted(),
  adminTourStep: 0,
  showAdminTour: false,
  startAdminTour: () => set({ showAdminTour: true, adminTourStep: 0 }),
  nextAdminStep: () => set((s) => ({ adminTourStep: s.adminTourStep + 1 })),
  dismissAdminTour: () => {
    writeAdminCompleted(true);
    set({ showAdminTour: false, adminTourStep: 0, adminTourCompleted: true });
  },
}));
